import React from 'react';

import classes from './Checkbox.module.scss';

import { FormattedMessage } from 'react-intl';

const checkbox = ( props ) => {
    let inputElement = null;
    const inputClasses = [classes.InputElement, 'InputElement'];

    if (props.invalid && props.shouldValidate && props.touched) {
        inputClasses.push(classes.Invalid);
    }

    inputElement = <input
                type="checkbox"
                className={inputClasses.join(' ')}
                {...props.elementConfig}
                value={props.value}
                checked={props.checked}
                onChange={props.changed} />;
    
    
    let label;
    if(props.label) {
        label = <FormattedMessage id={props.id} defaultMessage={props.label}>{(msg) => msg}</FormattedMessage>
    } else {
        label = (props.icon) ? <img alt='' src={ props.icon }/> : null;
    }
    
    return (
        <div className={classes.Input}>
            {inputElement}
            <label className={classes.Label}>
                { label }
            </label>
            
        </div>
    );

};

export default checkbox;
